import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    BymoPagePropsContentSettingSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata
} from '../../client-server-common';


export namespace DoppeActionTypeIframe {

    export interface ActionSettings {
        iframeUrl: string;
    }

}

export const doppeActionTypeIframe = doppeActionTypeDefineMetadata<DoppeActionTypeIframe.ActionSettings>({
    id: 'io.bymo.action/iframe',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        iframeUrl: '',
    }),
    hasNoGoalMeasuring: false,
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            iframeUrl: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Url, BymoPagePropsContentSettingSemanticMeaning.EntityPageUrl)
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {},
        bindableContentSettingsNames: {}
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    isModalOpener: true,
    canRenderInPage: false,
    skipReportingOnGoalAchievedOnActionButtonClick: false,
    hasNoLockInnerCTA: true,
})

